<template>
  <div class="row">
    <rfid-history-modal
      v-if="dialogVisible"
      @close="dialogVisible = false"
      :rfid="rfidSelected"
    ></rfid-history-modal>
    <div class="col-lg-2 col-md-12 col-sm-12 mb-2">
      <el-card style="height: 100%" shadow="always">
        <div class="font-weight-bold text-cello">Filter by RFID</div>
        <small>(Enter RFIDs separated by comma or newline)</small>
        <el-input
          class="mt-3"
          type="textarea"
          v-model="search"
          :autosize="{ minRows: 20, maxRows: 20 }"
        />
        <div class="text-right">
          <el-button
            @click="clearSearch"
            class="action-btn w-5 mt-2 rounded"
            type="info"
            style="width: 65px"
            >Clear</el-button
          >
          <el-button
            @click="searchByGroup"
            class="action-btn w-5 mt-2 rounded"
            type="primary"
            style="width: 65px"
            >Search</el-button
          >
        </div>
      </el-card>
    </div>
    <div class="col-lg-10 col-md-12 col-sm-12 container-fluid">
      <div class="row" v-if="filter">
        <div class="col-lg-6 col-md-6 col-sm-12 p-0">
          <div
            class="font-weight-bold text-cello d-flex align-items-center justify-content-between mb-1"
          >
            Producer
            <el-input
              v-model="businesses_search"
              class="w-50"
              size="mini"
              placeholder="Search producer"
            ></el-input>
          </div>
          <el-card
            shadow="always"
            style="height: 250px; overflow-y: auto; overflow-x: hidden"
            :body-style="{ padding: '10px' }"
          >
            <el-checkbox-group v-model="businesses_ids">
              <el-checkbox
                class="w-100 m-0"
                v-for="business in businesses.filter(
                  (data) =>
                    !businesses_search ||
                    data.name
                      .toLowerCase()
                      .includes(businesses_search.toLowerCase()),
                )"
                :key="business.id"
                :label="business.id"
                >{{ business.name }}</el-checkbox
              >
            </el-checkbox-group>
          </el-card>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <div
            class="font-weight-bold text-cello d-flex align-items-center justify-content-between mb-1"
          >
            Trade #
            <el-select
              v-model="purchase_search"
              multiple
              filterable
              remote
              reserve-keyword
              @change="selectPurchases"
              placeholder="Search Trade #"
              :remote-method="getPurchases"
              size="mini"
              class="w-50"
            >
              <el-option
                v-for="purchase in purchase_options"
                :key="purchase.id"
                :label="purchase.id"
                :value="purchase.id"
                >{{ purchase.ref_id }}
              </el-option>
            </el-select>
          </div>
          <el-card
            shadow="always"
            style="height: 250px; overflow-y: auto; overflow-x: hidden"
            :body-style="{ padding: '10px' }"
          >
            <div v-if="purchases_loading">
              <small>Loading...</small>
            </div>
            <el-checkbox-group v-model="purchases_ids" class="row">
              <el-checkbox
                class="col-3 m-0"
                v-for="purchase in purchases"
                :key="purchase.id"
                :label="purchase.id"
                >{{ purchase.ref_id }}</el-checkbox
              >
            </el-checkbox-group>
          </el-card>
        </div>

        <div class="col-lg-2 col-md-2 col-sm-12 pl-0">
          <div class="font-weight-bold text-cello">Status</div>
          <div class="mt-2 shadow-sm p-2 bg-white rounded">
            <el-checkbox-group v-model="statuses_ids">
              <el-checkbox
                class="w-100 text-uppercase"
                v-for="status in statuses"
                :key="status.id"
                :label="status.id"
              >
                <span class="fa-sm">{{ status.name }}</span>
              </el-checkbox>
            </el-checkbox-group>
          </div>

          <div class="mt-2 shadow-sm p-2 bg-white rounded">
            <el-checkbox-group v-model="deceased_status_ids">
              <el-checkbox
                class="w-100 text-uppercase"
                v-for="status in deceased_statuses"
                :key="status.id"
                :label="status.id"
                ><span class="fa-sm">{{ status.name }}</span></el-checkbox
              >
            </el-checkbox-group>
          </div>
        </div>
        <div class="col-12 text-right mb-4">
          <el-button
            @click="clearSearch"
            class="action-btn w-5 mt-2 rounded"
            type="info"
            style="width: 65px"
            >Clear</el-button
          >
          <el-button
            @click="searchByGroup"
            class="action-btn w-5 mt-2 rounded"
            type="primary"
            style="width: 65px"
            >Search</el-button
          >
          <el-button
            @click="filter = false"
            class="action-btn w-5 mt-2 rounded"
            type="danger"
            style="width: 65px"
            >Close</el-button
          >
        </div>
      </div>
      <div class="row" v-loading="loading">
        <div class="col-12 pl-0">
          <el-card
            shadow="always"
            style="height: 100%"
            :body-style="{ padding: '0px' }"
          >
            <div
              role="warning"
              class="alert alert-warning m-0 py-1 px-2 text-navy mb-2"
              v-if="message"
            >
              {{ message }}
            </div>
            <div class="row p-2">
              <div class="col-12 text-right">
                <el-button
                  @click="exportCSV"
                  :loading="loading_export"
                  class="btn-secondary"
                  >Export CSV</el-button
                >
                <el-button
                  @click="filter = true"
                  v-if="!filter"
                  class="btn-secondary"
                  >Filter</el-button
                >
              </div>
              <div class="col-12">
                <el-table
                  :data="rfidList.data"
                  @sort-change="handleSortChange"
                  :empty-text="message"
                >
                  <el-table-column label="RFID" prop="rfid">
                    <template slot-scope="scope">
                      <a href="" @click="showModal($event, scope.row.rfid)">
                        {{ scope.row.rfid }}
                      </a>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="Trade #"
                    sortable="custom"
                    prop="purchase_id"
                  >
                    <template slot-scope="scope">
                      {{ scope.row.purchase.ref_id }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="Expiry"
                    sortable="custom"
                    prop="purchase.invoice_due_date"
                  >
                    <template slot-scope="scope">
                      {{
                        !scope.row.sale_id &&
                        scope.row.purchase.invoice_due_date
                          ? moment(scope.row.purchase.invoice_due_date).format(
                              "DD/MM/YYYY",
                            )
                          : ""
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column label="Sale" prop="sale_id">
                    <template slot-scope="scope">
                      <span v-if="scope.row.sale">
                        {{ scope.row.sale_id }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column label="Producer" prop="purchase_id">
                    <template slot-scope="scope">
                      <a
                        v-if="scope.row.purchase && scope.row.purchase.business"
                        :href="`businesses/${scope.row.purchase.business_id}`"
                      >
                        {{ scope.row.purchase.business.name }}
                      </a>
                    </template>
                  </el-table-column>
                  <el-table-column label="Status" prop="sale_id">
                    <template slot-scope="scope">
                      <div
                        style="width: 110px"
                        :class="statusClass(scope.row)"
                        class="alert py-0 text-center px-2"
                      >
                        {{ status(scope.row) }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="" prop="sale_id">
                    <template slot-scope="scope">
                      <div
                        style="width: 110px"
                        v-if="scope.row.deceased_at"
                        class="alert py-0 text-center px-2 alert-warning"
                      >
                        Deceased
                      </div>
                    </template>
                  </el-table-column>

                  <el-table-column type="expand">
                    <template slot-scope="props">
                      <div class="row">
                        <div
                          class="col-3 fa-sm"
                          v-for="purchase in props.row.allAgencyPurchases"
                          :key="purchase.id"
                        >
                          {{ purchase.ref_id }}
                          |
                          <a
                            v-if="purchase"
                            :href="`businesses/${purchase.business_id}`"
                            target="_blank"
                          >
                            {{ purchase.business.name }}
                          </a>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div
                class="col-12 py-3 d-flex justify-content-center justify-content-xl-end"
              >
                <el-pagination
                  layout="prev, pager, next, total"
                  :current-page.sync="currentPage"
                  @current-change="handleCurrentChange"
                  prev-text="Prev"
                  next-text="Next"
                  :background="true"
                  :page-size="perPage"
                  :page-count="rfidList.last_page"
                  :total="rfidList.total"
                />
              </div>
            </div>
          </el-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import OttleyFormatter from "../../../mixins/OttleyFormatter";
import RfidLookup from "../../modelsPortal/RfidLookup";
import Business from "../../modelsPortal/Business";
import Purchase from "../../modelsPortal/Purchase";
export default {
  mixins: [OttleyFormatter],
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  mounted() {},
  data() {
    return {
      filter: false,
      message: "Please use the filter to search",
      rfidList: {},
      loading: false,
      loading_export: false,
      purchases: [],
      query: "",
      perPage: 15,
      currentPage: 1,
      search: "",
      options: [],
      dialogVisible: false,
      rfidSelected: null,
      businesses: [],
      businesses_search: null,
      businesses_ids: [],

      purchases: [],
      purchases_ids: [],
      purchases_loading: false,
      purchases_page: 0,
      purchase_search: "",
      purchase_options: [],

      statuses_ids: [],
      deceased_status_ids: [],

      statuses: [
        { id: 1, name: "Open" },
        { id: 2, name: "Closed" },
      ],
      deceased_statuses: [
        { id: 1, name: "Deceased" },
        { id: 2, name: "Not Deceased" },
      ],
    };
  },
  beforeMount() {
    this.getBusinesses();
  },
  mounted() {
    this.echoListen();
  },
  watch: {
    businesses_ids: {
      handler: function (newValue, oldValue) {
        if (newValue.length == 0) {
          this.purchases_ids = [];
          this.purchases = [];
        }
        this.getPurchases(null);
      },
    },
  },
  methods: {
    echoListen() {
      this.echoListener = Echo.private(
        `rfid-search-export.${this.user.id}`,
      ).listen(".rfid-search-export", async (event) => {
        if (event.url) window.open(event.url, "_blank");
        this.loading_export = false;
      });
    },
    clearSearch() {
      this.search = "";
      this.options = [];
      this.businesses_ids = [];
      this.statuses_ids = [];

      this.purchases_ids = [];
      this.purchase_search = "";
      this.purchase_options = [];

      this.deceased_status_ids = [];
      this.businesses_search = "";
      this.orderBy = "";
      this.rfidList = [];
      this.message = "Please use any filter to search";
    },
    selectPurchases() {
      this.purchases_ids = [...this.purchases_ids, ...this.purchase_search];
      this.purchase_search.map((_item) => {
        console.log(_item);
        if (!this.purchases.find((e) => e.id == _item)) {
          let purchase_option = this.purchase_options.find(
            (p) => p.id == _item,
          );
          if (purchase_option)
            this.purchases.push({
              id: purchase_option.id,
              ref_id: purchase_option.ref_id,
            });
        }
      });
      this.purchase_search = [];
    },
    getPurchases(query) {
      this.purchases_loading = true;
      this.purchases_page++;
      let purchase = Purchase.select("id", "ref_id");
      purchase
        .whereIn("where_not_in_id", this.purchases_ids)
        .whereIn("business_id", this.businesses_ids)
        .orderBy("id");

      if (query && query != "") {
        purchase
          .page(1)
          .params({ per_page: 30 })
          .where("where_like_id", query)
          .get()
          .then((res) => {
            this.purchase_options = res.data;
            this.purchases_loading = false;
          })
          .catch((errors) => {
            this.$message({
              type: "error",
              message: "Looks like something went wrong.",
            });
          });
      } else {
        if (this.businesses_ids.length > 0) {
          purchase
            .params({ no_paginate: true })
            .where("open_trades", true)
            .get()
            .then((res) => {
              this.purchases = res.map((p) => ({
                id: p.id,
                ref_id: p.ref_id,
              }));
              
              this.purchases_loading = false;
            })
            .catch((errors) => {
              console.log(errors);
              this.$message({
                type: "error",
                message: "Looks like something went wrong.",
              });
            });
        }
        this.purchases_loading = false;
      }
    },
    getBusinesses() {
      let businesses = Business.select("id", "name");

      businesses
        .get()
        .then((res) => {
          this.businesses = res;
        })
        .catch((errors) => {
          this.$message({
            type: "error",
            message: "Looks like something went wrong.",
          });
        });
    },
    showModal(e, rfid) {
      e.preventDefault();
      this.rfidSelected = rfid;
      this.dialogVisible = true;
    },
    handleSortChange(column) {
      if (column.order == "ascending") {
        if (column.prop == "purchase_id") this.orderBy = column.prop;
        else this.orderBy = "-sale_id," + column.prop;
      } else if (column.order == "descending") {
        if (column.prop == "purchase_id") this.orderBy = "-" + column.prop;
        else this.orderBy = "sale_id,-" + column.prop;
      } else {
        this.orderBy = "";
      }
      this.getData(1);
    },
    getData(page) {
      let filtered = false;
      let rfidList = RfidLookup.page(page)
        .select({
          "allAgencyPurchases.purchases": ["id", "business_id"],
          "purchase.purchases": [
            "id",
            "ref_id",
            "business_id",
            "invoice_due_date",
            "bill_value_ex",
            "number_of_head",
          ],
        })
        .params({ per_page: this.perPage })
        .include(
          "purchase.business.agency",
          "purchase.additionalCosts",
          "sale",
          "nlisDeceased",
          "allAgencyPurchases.business",
        );

      if (this.options.length > 0) {
        rfidList.whereIn("rfid", this.options);
        filtered = true;
      }

      rfidList.where("not_null_rfid", false);

      if (this.businesses_ids.length > 0) {
        rfidList.whereIn("business_id", this.businesses_ids);
        filtered = true;
      }
      if (this.purchases_ids.length > 0) {
        rfidList.whereIn("purchase_id", this.purchases_ids);
        filtered = true;
      }
      if (this.statuses_ids.length > 0) {
        rfidList.where("status", this.statuses_ids.join(","));
        filtered = true;
      }
      if (this.deceased_status_ids.length > 0) {
        rfidList.where("deceased_status", this.deceased_status_ids.join(","));
        filtered = true;
      }
      if (!filtered) {
        this.message = "A filter is required to find records";
        return;
      } else {
        this.loading = true;
      }

      if (this.orderBy) {
        rfidList.orderBy(this.orderBy);
      } else {
        rfidList.orderBy("-created_at", "-purchase_id");
      }

      rfidList
        .get()
        .then((res) => {
          this.rfidList = res;
          if (res.total == 0) {
            this.message =
              "There are not records. Change filters to find records";
          } else {
            this.message = null;
          }
          this.currentPage = page;
        })
        .catch((errors) => {
          this.$message({
            type: "error",
            message: "Looks like something went wrong.",
          });
        })
        .finally((_) => {
          this.loading = false;
        });
    },
    searchByGroup() {
      this.orderBy = "";
      if (this.search) {
        this.options = this.search.trim().replace(/\n/g, ",").split(",");
        if (this.options.length > 0) {
          this.options = this.options.map((element) => {
            return element.trim();
          });
        }
      } else {
        this.options = [];
      }
      this.getData(1);
    },
    handleCurrentChange(page = 1) {
      this.getData(page);
    },
    status(row) {
      if (row.deleted_at) return "Deleted";
      else if (row.closed_out) return "Closed";
      else return "Open";
    },
    statusClass(row) {
      if (row.deleted_at) return "alert-danger";
      else if (row.closed_out) return "alert-success";
      else return "alert-info";
    },
    exportCSV() {
      if (
        !this.rfidList.total ||
        this.rfidList.total > 10000 ||
        this.rfidList.total == 0
      ) {
        this.$message({
          type: "error",
          message:
            "We are unable to export this data, please apply any filter to export.",
        });
        return;
      }
      this.loading_export = true;
      let rfidList = RfidLookup.where("not_null_rfid", false).params({
        export: true,
      });

      if (this.options.length > 0) rfidList.whereIn("rfid", this.options);

      if (this.businesses_ids.length > 0)
        rfidList.whereIn("business_id", this.businesses_ids);

      if (this.purchases_ids.length > 0)
        rfidList.whereIn("purchase_id", this.purchases_ids);

      if (this.statuses_ids.length > 0)
        rfidList.where("status", this.statuses_ids.join(","));

      if (this.deceased_status_ids.length > 0)
        rfidList.where("deceased_status", this.deceased_status_ids.join(","));

      if (this.orderBy) {
        rfidList.orderBy(this.orderBy);
      } else {
        rfidList.orderBy("-created_at", "-purchase_id");
      }

      rfidList
        .get()
        .then((res) => {
          //this.rfidList = res;
        })
        .catch((errors) => {
          this.loading_export = false;
          this.$message({
            type: "error",
            message: "Looks like something went wrong.",
          });
        });
    },
  },
};
</script>
